(function () {
  const root = document.getElementById('sophi-widget');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const endpoint = root.dataset.sophiEndpoint;
  const tab = root.querySelector('.sophi-tab');
  const panel = root.querySelector('.sophi-panel');
  const messages = root.querySelector('[data-sophi-messages]');
  const form = root.querySelector('[data-sophi-form]');
  const input = root.querySelector('[data-sophi-input]');
  const imageInput = root.querySelector('[data-sophi-image]');
  const chips = root.querySelector('[data-sophi-chips]');
  const plan = root.querySelector('[data-sophi-plan]');
  const memoryControl = root.querySelector('[data-sophi-memory]');
  const customerId = root.dataset.customerId || '';
  const customerNumber = root.dataset.customerNumber || '';
  const customerIdentityToken = root.dataset.customerIdentityToken || '';
  const sessionKey = 'sophi_session_id_v3';
  const guestKey = 'lumira_guest_id';
  const projectKey = 'lumira_sophi_project_token_v1';
  const memoryKey = 'sophi_memory_consent_v1';
  const selectedProductKey = 'sophi_selected_product_v3';
  const openClass = 'sophi-chat-open';
  const starterMarkup = messages.innerHTML;
  const history = [];
  let pendingImage = null;
  let latestProducts = [];
  let resumePromise = Promise.resolve();

  function memoryConsent() {
    return window.localStorage.getItem(memoryKey) === 'true';
  }

  function guestId() {
    if (!memoryConsent()) return '';
    let value = window.localStorage.getItem(guestKey);
    if (!value) {
      value = 'lumira_guest_' + (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2));
      window.localStorage.setItem(guestKey, value);
    }
    return value;
  }

  function projectToken() {
    let value = window.localStorage.getItem(projectKey);
    if (!value) {
      const random = window.crypto && crypto.getRandomValues
        ? Array.from(crypto.getRandomValues(new Uint8Array(32)), (byte) => byte.toString(16).padStart(2, '0')).join('')
        : Array.from({ length: 4 }, () => Math.random().toString(36).slice(2)).join('');
      value = random.slice(0, 160);
      window.localStorage.setItem(projectKey, value);
    }
    return value;
  }

  if (memoryControl) {
    memoryControl.checked = memoryConsent();
    memoryControl.addEventListener('change', () => {
      window.localStorage.setItem(memoryKey, memoryControl.checked ? 'true' : 'false');
      if (memoryControl.checked) guestId();
    });
  }

  function sessionId() {
    let value = window.localStorage.getItem(sessionKey);
    if (!value) {
      value = 'sophi-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
      window.localStorage.setItem(sessionKey, value);
    }
    return value;
  }

  function selectedProductContext() {
    const currentId = root.dataset.currentProductId || '';
    const currentTitle = root.dataset.currentProductTitle || '';
    const currentUrl = root.dataset.currentProductUrl || '';
    if (currentId) {
      return { id: currentId, title: currentTitle, url: currentUrl };
    }
    try {
      return JSON.parse(window.localStorage.getItem(selectedProductKey) || '{}');
    } catch (_error) {
      return {};
    }
  }

  function rememberSelectedProduct(product) {
    if (!product || !product.id) return;
    window.localStorage.setItem(selectedProductKey, JSON.stringify({
      id: String(product.id),
      title: product.title || '',
      url: productUrl(product)
    }));
  }

  function openPanel() {
    root.classList.add('is-open');
    document.documentElement.classList.add(openClass);
    tab.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    panel.setAttribute('aria-modal', 'true');
    setTimeout(() => input.focus(), 80);
  }

  function closePanel() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove(openClass);
    tab.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('aria-modal', 'false');
  }

  function money(value) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(value || 0));
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    })[char]);
  }

  function paragraphs(text) {
    return String(text || '').split(/\n+/).filter(Boolean).map((line) => `<p>${escapeHtml(line)}</p>`).join('');
  }

  function scrollDown() {
    messages.scrollTop = messages.scrollHeight;
  }

  function addMessage(role, html, className) {
    const article = document.createElement('article');
    article.className = `sophi-message sophi-message--${role}${className ? ` ${className}` : ''}`;
    article.innerHTML = html;
    messages.appendChild(article);
    scrollDown();
    return article;
  }

  function typing() {
    return addMessage('assistant', '<span class="sophi-typing" role="status"><span class="sophi-sr">Sophi is typing</span><i></i><i></i><i></i></span>');
  }

  function productUrl(product) {
    return product.url || product.product_url || '#';
  }

  function productBrandLine(product) {
    const brand = product.brand || product.vendor || 'Lumira Furniture';
    const type = product.product_type || product.category || '';
    return [brand, type].filter(Boolean).join(' - ');
  }

  function modelUrl(product) {
    return product.glb_url || product.model_url || product.model3d_url || product.usdz_url || '';
  }

  function hasModelUrl(product) {
    return Boolean(modelUrl(product));
  }

  function isSceneWorthy(product) {
    return hasModelUrl(product) || Boolean(product.image || product.image_url) && Boolean(product.dimensions || product.product_type || product.category);
  }

  function shouldShowEnvironmentMode(products) {
    const sceneWorthy = (products || []).filter(isSceneWorthy);
    return sceneWorthy.some(hasModelUrl) || sceneWorthy.length >= 2;
  }

  function productCard(product) {
    const stock = product.in_stock ? 'In stock' : (product.next_eta ? `ETA ${escapeHtml(product.next_eta)}` : 'Check availability');
    const title = escapeHtml(product.title);
    const url = escapeHtml(productUrl(product));
    const variantId = escapeHtml(product.variant_id);
    const addDisabled = product.variant_id ? '' : ' disabled aria-disabled="true"';
    return `
      <article class="sophi-product-card" data-variant-id="${escapeHtml(product.variant_id)}">
        <a class="sophi-product-media" href="${url}" data-sophi-view data-product-id="${escapeHtml(product.id)}" data-product-title="${title}" aria-label="View ${title}">
          <img src="${escapeHtml(product.image || product.image_url)}" alt="${title}" loading="lazy">
        </a>
        <div class="sophi-product-body">
          <p class="sophi-product-brand">${escapeHtml(productBrandLine(product))}</p>
          <h3>${title}</h3>
          <div class="sophi-product-price">${money(product.price)}</div>
          ${product.dimensions ? `<p class="sophi-product-meta">${escapeHtml(product.dimensions)}</p>` : ''}
          <span class="sophi-product-stock">${stock}</span>
          ${product.match_reason ? `<p class="sophi-product-reason">${escapeHtml(product.match_reason)}</p>` : ''}
          <div class="sophi-product-actions">
            <a class="sophi-product-view" href="${url}" data-sophi-view data-product-id="${escapeHtml(product.id)}" data-product-title="${title}">View</a>
            <button class="sophi-product-add" type="button" data-sophi-add="${variantId}" aria-label="Add ${title} to cart"${addDisabled}>Add to Cart</button>
          </div>
        </div>
      </article>
    `;
  }

  function renderProducts(products) {
    if (!products || !products.length) return '';
    const environmentButton = shouldShowEnvironmentMode(products)
      ? '<button class="sophi-environment" type="button" data-sophi-environment>Enter Environment Mode</button>'
      : '';
    return `
      <section class="sophi-products" aria-label="Recommended Lumira pieces">
        <div class="sophi-products-track">
          ${products.map(productCard).join('')}
        </div>
        ${environmentButton}
      </section>
    `;
  }

  function renderEdesignUpsell(upsell) {
    if (!upsell || !upsell.triggered) return '';
    return `
      <section class="sophi-edesign" aria-label="Lumira eDesign">
        <button type="button" data-sophi-edesign>${escapeHtml(upsell.cta_label || 'Start eDesign — $1,000 deposit')}</button>
      </section>
    `;
  }

  function renderPlan(roomPlan, products) {
    if (!products || !products.length) {
      plan.hidden = true;
      plan.innerHTML = '';
      return;
    }
    const hasTotal = roomPlan && roomPlan.total_price !== undefined && roomPlan.total_price !== null;
    const hasRemaining = roomPlan && roomPlan.budget_remaining !== undefined && roomPlan.budget_remaining !== null;
    const total = hasTotal ? `Room plan total: ${money(roomPlan.total_price)}` : `Room plan: ${products.length} recommended piece${products.length === 1 ? '' : 's'}`;
    const remaining = hasRemaining ? `<span>Budget remaining: ${money(roomPlan.budget_remaining)}</span>` : '<span>Curated from live Lumira inventory</span>';
    plan.hidden = false;
    plan.innerHTML = `
      <div>
        <strong>${total}</strong>
        ${remaining}
      </div>
      <button type="button" data-sophi-add-all>Add All to Cart</button>
    `;
  }

  function renderChips(items) {
    chips.innerHTML = '';
    (items || []).forEach((label) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      chips.appendChild(button);
    });
  }

  async function addVariants(variantIds) {
    const ids = variantIds.filter(Boolean);
    if (!ids.length) return;
    const payload = { items: ids.map((id) => ({ id: Number(id), quantity: 1 })) };
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error('Could not add item to cart');
    window.location.href = '/cart';
  }

  function openEnvironmentMode() {
    const products = latestProducts.filter(isSceneWorthy);
    if (!products.length) return;
    const detail = {
      source: 'sophi',
      products: products.map((product) => ({
        title: product.title || '',
        url: productUrl(product),
        image: product.image || product.image_url || '',
        glb_url: product.glb_url || '',
        usdz_url: product.usdz_url || '',
        variant_id: product.variant_id || ''
      }))
    };

    root.dispatchEvent(new CustomEvent('sophi:environment-mode', { bubbles: true, detail }));
    window.dispatchEvent(new CustomEvent('sophi:environment-mode', { detail }));

    const localViewer = document.querySelector('[data-lumira-3d-open]');
    if (localViewer) {
      closePanel();
      localViewer.click();
      return;
    }

    const modelProduct = products.find(hasModelUrl) || products[0];
    const target = productUrl(modelProduct);
    if (target && target !== '#') {
      const joiner = target.includes('?') ? '&' : '?';
      window.location.href = `${target}${joiner}sophi_environment=1`;
      return;
    }

    addMessage('assistant', '<p>Environment Mode is ready when a 3D-ready product page is open.</p>');
  }

  async function resumeConversation() {
    const selected = selectedProductContext();
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          session_id: sessionId(),
          intent: 'resume',
          customer_id: customerId,
          customer_identity_token: customerIdentityToken,
          project_token: projectToken(),
          guest_id: guestId(),
          memory_consent: memoryConsent(),
          selected_product_id: selected.id || '',
          selected_product_title: selected.title || '',
          current_product_url: selected.url || window.location.href
        })
      });
      if (!response.ok) throw new Error('Could not resume Sophi');
      const data = await response.json();
      const restored = (data.history || []).filter((row) => (
        row && (row.role === 'user' || row.role === 'assistant') && row.content
      ));
      history.splice(0, history.length, ...restored);
      if (restored.length) {
        messages.innerHTML = '';
        restored.forEach((row) => {
          addMessage(row.role === 'user' ? 'customer' : 'assistant', paragraphs(row.content));
        });
      } else {
        messages.innerHTML = starterMarkup;
      }
      latestProducts = data.products || [];
      if (latestProducts.length) {
        addMessage('assistant', renderProducts(latestProducts), 'sophi-message--products');
      }
      renderPlan(data.room_plan, latestProducts);
      renderChips(data.suggested_followup || []);
    } catch (_error) {
      // The chat remains usable with the local starter if resume is unavailable.
    }
  }

  async function sendMessage(text) {
    await resumePromise;
    const clean = String(text || '').trim();
    if (!clean && !pendingImage) return;
    const priorHistory = history.slice(-12);
    addMessage('customer', paragraphs(clean || 'Room photo uploaded'));
    history.push({ role: 'user', content: clean });
    const thinking = typing();
    const selected = selectedProductContext();
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          session_id: sessionId(),
          message: clean,
          image_url: pendingImage,
          conversation_history: priorHistory,
          customer_id: customerId,
          customer_identity_token: customerIdentityToken,
          project_token: projectToken(),
          guest_id: guestId(),
          memory_consent: memoryConsent(),
          selected_product_id: selected.id || '',
          selected_product_title: selected.title || '',
          current_product_url: selected.url || window.location.href
        })
      });
      if (!response.ok) throw new Error('Sophi is unavailable');
      const data = await response.json();
      thinking.remove();
      latestProducts = data.products || [];
      addMessage('assistant', paragraphs(data.message));
      if (data.edesign_upsell && data.edesign_upsell.triggered) addMessage('assistant', renderEdesignUpsell(data.edesign_upsell), 'sophi-message--products');
      if (latestProducts.length) addMessage('assistant', renderProducts(latestProducts), 'sophi-message--products');
      renderPlan(data.room_plan, latestProducts);
      renderChips(data.suggested_followup || []);
      history.push({ role: 'assistant', content: data.message || '' });
    } catch (error) {
      thinking.remove();
      addMessage('assistant', '<p>I could not reach the design studio just now. Please try again in a moment.</p>');
    } finally {
      pendingImage = null;
      imageInput.value = '';
    }
  }

  tab.addEventListener('click', openPanel);
  root.querySelectorAll('[data-sophi-close]').forEach((button) => button.addEventListener('click', closePanel));

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const text = input.value;
    input.value = '';
    sendMessage(text);
  });

  imageInput.addEventListener('change', () => {
    const file = imageInput.files && imageInput.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      pendingImage = reader.result;
      if (!input.value.trim()) input.value = 'Here is my room photo. Please design the space.';
      openPanel();
    };
    reader.readAsDataURL(file);
  });

  chips.addEventListener('click', (event) => {
    const button = event.target.closest('button');
    if (!button) return;
    input.value = button.textContent;
    sendMessage(input.value);
    input.value = '';
  });

  root.addEventListener('click', (event) => {
    const view = event.target.closest('[data-sophi-view]');
    if (view) {
      const product = latestProducts.find((row) => String(row.id || '') === String(view.dataset.productId || '')) || {
        id: view.dataset.productId || '',
        title: view.dataset.productTitle || '',
        url: view.getAttribute('href') || ''
      };
      rememberSelectedProduct(product);
      return;
    }
    const add = event.target.closest('[data-sophi-add]');
    if (add) {
      if (add.disabled) return;
      addVariants([add.dataset.sophiAdd]).catch(() => addMessage('assistant', '<p>I could not add that piece to cart. Please open the product and add it from there.</p>'));
      return;
    }
    const addAll = event.target.closest('[data-sophi-add-all]');
    if (addAll) {
      addVariants(latestProducts.map((product) => product.variant_id)).catch(() => addMessage('assistant', '<p>I could not add the full plan to cart. Please add the pieces one at a time.</p>'));
      return;
    }
    const environment = event.target.closest('[data-sophi-environment]');
    if (environment) {
      openEnvironmentMode();
      return;
    }
    const edesign = event.target.closest('[data-sophi-edesign]');
    if (edesign) {
      window.location.href = '/edesign?source=sophi';
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.classList.contains('is-open')) closePanel();
  });

  resumePromise = resumeConversation();
})();


/* Mobile chat belongs to the header, never over product content. */
(function () {
  const root = document.getElementById('sophi-widget');
  const trigger = root && root.querySelector('.sophi-tab');
  const account = document.querySelector('.ln-header .ln-account');
  if (!root || !trigger || !account || account.querySelector('.sophi-mobile-launch')) return;
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'sophi-mobile-launch';
  button.setAttribute('aria-label', 'Open Sophi design chat');
  button.setAttribute('aria-controls', trigger.getAttribute('aria-controls') || 'sophi-panel');
  button.setAttribute('aria-expanded', trigger.getAttribute('aria-expanded') || 'false');
  const icon = trigger.querySelector('svg');
  if (icon) button.appendChild(icon.cloneNode(true));
  const label = document.createElement('span');
  label.textContent = 'Sophi';
  button.appendChild(label);
  button.addEventListener('click', () => trigger.click());
  account.insertBefore(button, account.firstChild);
  root.classList.add('has-mobile-header-launch');
  account.classList.add('has-sophi-launch');
  const sync = () => button.setAttribute('aria-expanded', trigger.getAttribute('aria-expanded') || 'false');
  new MutationObserver(sync).observe(trigger, {attributes: true, attributeFilter: ['aria-expanded']});
  root.querySelectorAll('[data-sophi-close]').forEach(close => close.addEventListener('click', () => {
    if (window.matchMedia('(max-width: 700px)').matches) button.focus();
  }));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && window.matchMedia('(max-width: 700px)').matches &&
        button.getAttribute('aria-expanded') === 'true') button.focus();
  }, true);
})();
